import styled from 'styled-components'
import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'

import { media } from '../../src/utils/style-utils'
import { backgroundColors } from '../../src/styles/backgroundColors'
import RichText from '../../src/components/RichText'
import { SCALEUP_HOVER } from '../../src/utils/animation-config'
import { FullScreenCardGridStyles } from '../../src/layout/grid/Grid'
import { CtaSliceSlice } from '../../prismicio-types'
import { getLinkUrl } from '../../src/utils/ts-helpers'

const CtaSlice = ({ slice }: { slice: CtaSliceSlice }) => {
	const backgroundColor = backgroundColors(slice.primary.backgroundColor ?? 'Baby Blue')
	const [secondaryColor, setSecondaryColor] = useState('var(--neon)')

	useEffect(() => {
		if (backgroundColor == 'var(--deep-blue)') {
			setSecondaryColor('var(--neon)')
		} else if (backgroundColor == 'var(--orange)') {
			setSecondaryColor('var(--deep-blue)')
		} else if (backgroundColor == 'var(--neon)') {
			setSecondaryColor('var(--deep-blue)')
		}
	}, [backgroundColor])

	return (
		<Container style={{ background: backgroundColor }}>
			<StyledRichText
				content={slice.primary.title}
				textColor={secondaryColor}
			/>
			<StyledButtons>
				{slice.primary.secondaryButtonText && (
					<StyledSecondaryRoundedLinkButton
						href={getLinkUrl(slice.primary.secondaryButtonLink)}
						whileHover={SCALEUP_HOVER}
						style={{ color: secondaryColor, backgroundColor: backgroundColor }}
					>
						{slice.primary.secondaryButtonText}
					</StyledSecondaryRoundedLinkButton>
				)}
				<StyledRoundedLinkButton
					href={getLinkUrl(slice.primary.buttonLink)}
					whileHover={SCALEUP_HOVER}
					style={{ color: backgroundColor, backgroundColor: secondaryColor }}
				>
					{slice.primary.buttonText}
				</StyledRoundedLinkButton>
			</StyledButtons>
		</Container>
	)
}

export default CtaSlice

const Container = styled.div`
	${FullScreenCardGridStyles}

	padding: 5px 68px 5px 68px;
	border-radius: 56px;

	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;

	color: var(--neon);

	${media.desktopSm`
		flex-direction: column;
		text-align: center;
		justify-content: center;
		padding: 10px;
		padding-bottom: 40px;

	`}
`

const StyledRichText = styled(RichText)<{ textColor: string }>`
	color: ${(p) => p.textColor};

	p {
		font-family: var(--font-atyp-display);
		font-style: normal;
		font-weight: 500;
		font-size: 2.5rem;
		line-height: 3.5rem;

		${media.phone`
			text-align: center;
		`}
	}
`

const StyledButtons = styled.div`
	display: flex;
	gap: 1rem;
	justify-content: center;
	align-items: center;

	a {
		cursor: pointer;
		display: flex;
		align-items: center;
		font-family: var(--font-atyp-display);
		text-align: center;
		border-radius: 30px;
		padding: 16px 32px;
		height: 56px;
		font-style: normal;
		font-weight: 500;
		font-size: 1.5rem;
		line-height: 2rem;

		&:focus-visible {
			outline: 3px solid var(--orange);
		}
	}

	${media.tabletMd`
		gap: 1.5rem;
		flex-direction: column;
`}
`

const StyledRoundedLinkButton = styled(motion.a)`
	border: none;
`

const StyledSecondaryRoundedLinkButton = styled(motion.a)`
	border: 2px solid var(--neon);
`
